"use client";
import Image from "next/image";

import school from "@/assets/images/icon/school.svg";
import school2 from "@/assets/images/icon/school2.svg";
import school3 from "@/assets/images/icon/school3.svg";
import workshop from "@/assets/images/icon/store.svg";
import group from "@/assets/images/icon/Group2.svg";

import React from "react";

const BLockFeatureTwo = ({ data }: any) => {
  const selectElementById = (data: any, id: any) => {
    return data.find((element: any) => element.id === id);
  };

  return (
    <>
      <div
        className="d-flex flex-column flex-lg-column align-items-center p-3"
        style={{
          borderRadius: "1rem",
          backgroundColor: "#F5F5FF",
          border: "1px solid rgba(0, 0, 0, 0.1)",
          margin: "1%",
        }}
      >
        {/* Title */}
        <h2
          className="text-center mb-4"
          style={{
            fontWeight: 400,
            fontFamily: "Graphik",
            fontSize: "48px",
            color: "#212121",
          }}
        >
          Viva Facts
        </h2>

        {/* Facts container */}
        <div className="d-flex flex-wrap flex-lg-column gap-3 justify-content-center">
          {[1, 2, 3, 4, 5].map((seq) => {
            const fact = data.find(
              (element: any) =>
                element.attributes.Type === "Facts" &&
                element.attributes.Sequence === seq,
            );

            if (!fact) return null;

            const images = [group, school, workshop, school2, school3];
            const image = images[seq - 1];

            return (
              <div
                key={seq}
                className="d-flex align-items-center bg-white rounded p-3"
                style={{
                  minWidth: "250px",
                  maxWidth: "350px",
                }}
              >
                <Image
                  src={image}
                  alt={`Fact ${seq}`}
                  className="me-3"
                  style={{
                    width: "40px",
                    height: "40px",
                    objectFit: "contain",
                  }}
                />
                <div>
                  {fact.attributes.Content.split("\n").map(
                    (line: string, index: number) => (
                      <span
                        key={index}
                        style={{
                          color: index === 0 ? "#212121" : "#666",
                          fontWeight: index === 0 ? 500 : 400,
                          fontSize: "16px",
                          display: "block",
                          fontFamily: "Graphik",
                          textAlign: "left",
                        }}
                      >
                        {line}
                      </span>
                    ),
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default BLockFeatureTwo;
